module.exports = __webpack_public_path__ + "static/media/target-social.d2353cb6.png";